export default __webpack_public_path__ + "static/media/scss.901e146f.svg";